module.exports = __webpack_public_path__ + "static/img/materialsInfo30.168b49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo30.png
// module id = Rmhp
// module chunks = 2